const actions = {
  HOVER_NAME: 'HOVER_NAME',
  toogleHoverName: () => ({
    type: actions.HOVER_NAME,
  }),
};

export default actions;
